import { Navigate } from "react-router-dom";

import { useConfirmAction } from "./hook";

export const ConfirmPage = () => {
  const { shouldShowConfirmationModal, navigateTo } = useConfirmAction();

  return shouldShowConfirmationModal ? null : (
    <Navigate to={navigateTo || "/"} />
  );
};
